export enum STICKS_LENGTH {
  SMALL = 1.5,
  MEDIUM = 2.0,
  LARGE = 3.0,
}

export const STICKS_SIZE = [STICKS_LENGTH.SMALL, STICKS_LENGTH.MEDIUM, STICKS_LENGTH.LARGE];

export const STICK_MODEL_GROUND = ['7343', '7346', '7340'];
